import React, { useState, useEffect, useRef, useMemo } from "react";
import { downloadCsv } from "../common/sharedFunctions";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import moment from 'moment/min/moment-with-locales';
import AlertDialog from "../components/AlertDialog";
import EditIcon from '@mui/icons-material/Edit';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import { Badge, Tooltip, Box, Typography, IconButton } from "@mui/material";
import { ThemeProvider } from '@mui/material/styles';
import BlankTable from '../components/Table/BlankTable';
import localization from '../components/Table/Localization';
import { getLangKey } from "common/src/other/getLangKey";
import {
  C2,
  C2_FONT,
  c2TableTheme,
  c2TableOptions,
  c2TableStyle,
  c2Toolbar,
  c2Localization,
  C2TableCard,
  C2AddButton,
  C2EmptyState,
  C2UserAvatar,
  C2DocsChip,
  C2Switch,
  C2Select,
  C2StatusChip,
  isReuploadedAfterReject,
  getDriverApprovalStatus,
  hasPendingDocReview,
  isUserDocVerified,
  getUserDocTimestamp,
  C2VerifiedBadge,
  C2DocsBadge,
} from '../components/Table/C2UserTable';
import VerifyIdDocumentModal from '../components/VerifyIdDocumentModal';

export default function Users() {
  const navigate = useNavigate();
  const {id} = useParams();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    editUser,
    deleteUser,
    fetchUsersOnce,
    fetchZonificacionCities,
    fetchCars,
    fetchCarTypes,
  } = api;
  const [data, setData] = useState([]);
  const [docsUser, setDocsUser] = useState(null);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const zonificacionCities = useSelector((state) => state.zonificacion?.cities);
  const carlistdata = useSelector((state) => state.carlistdata?.cars);
  const cartypes = useSelector((state) => state.cartypes?.cars);
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const [role, setRole] = useState(null);
  const [fleetAdminsObj, setFleetAdminsObj] = useState();
  const [sortedData, SetSortedData] = useState([]);
  const [cityFilter, setCityFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [sortFilter, setSortFilter] = useState("createdAt_desc");
  const [dateFilter, setDateFilter] = useState("");
  const [vehicleFilter, setVehicleFilter] = useState("");
  const {state} = useLocation()
  const [currentPage,setCurrentPage] = useState(null)

  const citiesById = useMemo(() => {
    const map = {};
    (zonificacionCities || []).forEach((c) => {
      if (c?.id) map[c.id] = c.name || c.id;
    });
    return map;
  }, [zonificacionCities]);

  const cityFilterOptions = useMemo(() => {
    const options = new Map();
    (zonificacionCities || []).forEach((c) => {
      if (c?.id) options.set(c.id, c.name || c.id);
    });
    (data || []).forEach((d) => {
      if (d.cityId && !options.has(d.cityId)) {
        options.set(d.cityId, d.cityName || d.cityId);
      }
    });
    return Array.from(options.entries())
      .map(([id, name]) => ({ id, name }))
      .sort((a, b) => a.name.localeCompare(b.name, "es"));
  }, [zonificacionCities, data]);

  useEffect(()=>{
    setCurrentPage(state?.pageNo)
  },[state])
  
  const HandalePageChange = (page)=>{
    setCurrentPage(page)
  }

  useEffect(() => {
    dispatch(fetchUsersOnce());
    dispatch(fetchZonificacionCities());
    if (typeof fetchCars === "function") dispatch(fetchCars());
    if (typeof fetchCarTypes === "function") dispatch(fetchCarTypes());
  }, [dispatch, fetchUsersOnce, fetchZonificacionCities, fetchCars, fetchCarTypes]);

  const activeCarByDriver = useMemo(() => {
    const map = {};
    (carlistdata || []).forEach((c) => {
      if (c?.driver) {
        if (!map[c.driver] || c.active) {
          map[c.driver] = c;
        }
      }
    });
    return map;
  }, [carlistdata]);

  const vehicleFilterOptions = useMemo(() => {
    const set = new Set();
    (cartypes || []).forEach((ct) => {
      if (ct?.name) set.add(ct.name);
    });
    (data || []).forEach((d) => {
      if (d.carType) set.add(d.carType);
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b, "es"));
  }, [cartypes, data]);

  useEffect(() => {
    if (staticusers) {
      if (role === "admin") {
        let arr = staticusers.filter((user) => user.usertype === "fleetadmin");
        let obj = {};
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          let user = arr[i];
          arr2.push({
            id: user.id,
            desc:
              user.firstName +
              " " +
              user.lastName +
              " (" +
              (settings.AllowCriticalEditsAdmin
                ? user.mobile
                : t("hidden_demo")) +
              ") " +
              (settings.AllowCriticalEditsAdmin
                ? user.email
                : t("hidden_demo")),
          });
          obj[user.id] =
            user.firstName +
            " " +
            user.lastName +
            " (" +
            (settings.AllowCriticalEditsAdmin
              ? user.mobile
              : t("hidden_demo")) +
            ") " +
            (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo"));
        }
        setFleetAdminsObj(obj);
      }
      setTimeout(() => {
        setData(
          staticusers
            .filter(
              (user) =>
                user.usertype === "driver" &&
                ((user.fleetadmin === auth.profile.uid &&
                  auth.profile.usertype === "fleetadmin") ||
                  auth.profile.usertype === "admin")
            )
            .map((user) => {
              const car = activeCarByDriver[user.id];
              const resolvedCarType = user.carType || car?.carType || user.vehicleType || "";
              return {
                ...user,
                cityName:
                  user.cityName ||
                  (user.cityId ? citiesById[user.cityId] : "") ||
                  "",
                carType: resolvedCarType,
                vehicleNumber: user.vehicleNumber || car?.vehicleNumber || "",
              };
            })
        );
      }, 1000);
    } else {
      setData([]);
    }
    loaded.current = true;
  }, [
    staticusers,
    auth.profile.usertype,
    auth.profile.uid,
    settings.AllowCriticalEditsAdmin,
    role,
    t,
    citiesById,
    activeCarByDriver,
  ]);

  useEffect(()=>{
    if(data){
      SetSortedData(data.sort((a,b)=>(moment(b.createdAt) - moment(a.createdAt))))
    }
  },[data])

  const reuploadedCount = useMemo(() => {
    return (sortedData || []).filter(isReuploadedAfterReject).length;
  }, [sortedData]);

  const pendingDocsCount = useMemo(() => {
    return (sortedData || []).filter(hasPendingDocReview).length;
  }, [sortedData]);

  const filteredData = useMemo(() => {
    let list = (sortedData || []).filter((d) => {
      // 1. Filtro por Ciudad
      if (cityFilter) {
        if (cityFilter === "__none__") {
          if (d.cityId || d.cityName) return false;
        } else if (d.cityId !== cityFilter && d.cityName !== cityFilter) {
          return false;
        }
      }

      // 2. Filtro por Estado (Pendiente, Aprobado, Rechazado, Reenviaron documento, Por revisar documentos)
      if (statusFilter) {
        const isReup = isReuploadedAfterReject(d);
        if (statusFilter === "reuploaded") {
          if (!isReup) return false;
        } else if (statusFilter === "pending_docs") {
          if (!hasPendingDocReview(d)) return false;
        } else {
          const approval = getDriverApprovalStatus(d);
          if (statusFilter === "approved" && approval !== "approved") return false;
          if (statusFilter === "rejected" && approval !== "rejected") return false;
          if (statusFilter === "pending" && approval !== "pending") return false;
          if (statusFilter === "no_docs" && approval !== "no_docs") return false;
        }
      }

      // 3. Filtro por Día
      if (dateFilter) {
        if (!d.createdAt) return false;
        const driverDay = moment(d.createdAt).format("YYYY-MM-DD");
        if (driverDay !== dateFilter) return false;
      }

      // 4. Filtro por Tipo de Vehículo
      if (vehicleFilter) {
        const vType = d.carType || "";
        if (vehicleFilter === "__none__") {
          if (vType) return false;
        } else if (vType.toLowerCase() !== vehicleFilter.toLowerCase()) {
          return false;
        }
      }

      return true;
    });

    // 5. Ordenamiento (Registro recientes vs Últimos documentos subidos primero)
    if (sortFilter === "docs_desc") {
      return [...list].sort((a, b) => {
        const timeB = getUserDocTimestamp(b);
        const timeA = getUserDocTimestamp(a);
        if (timeB !== timeA) return timeB - timeA;
        return moment(b.createdAt) - moment(a.createdAt);
      });
    }

    return list;
  }, [sortedData, cityFilter, statusFilter, dateFilter, vehicleFilter, sortFilter]);
  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const handelApproved = (rowData) => {
    const updatedUser = { ...rowData, approved: !rowData.approved, adminApprovedTrue:true,  };

    dispatch(editUser(updatedUser.id, updatedUser));
    dispatch(fetchUsersOnce());
    return updatedUser;
  };
  const handelDriverActiveStatus = (rowData) => {
    const updatedUser = {
      ...rowData,
      driverActiveStatus: !rowData.driverActiveStatus,
    };

    dispatch(editUser(updatedUser.id, updatedUser));
    dispatch(fetchUsersOnce());
    return updatedUser;
  };

  const columns = [
    {
      title: t('createdAt'),
      field: 'createdAt',
      editable: 'never',
      defaultSort: 'desc',
      render: (rowData) => (rowData.createdAt ? moment(rowData.createdAt).format('lll') : null),
    },
    {
      title: t("first_name"),
      field: "firstName",
      initialEditValue: "",
      render: (rowData) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
            <Typography sx={{ fontFamily: C2_FONT, fontSize: "0.85rem", fontWeight: 600, color: C2.dark }}>
              {rowData.firstName || ""}
            </Typography>
            <C2VerifiedBadge user={rowData} />
          </Box>
        );
      },
    },
    { title: t("last_name"), field: "lastName", initialEditValue: "" },
    {
      title: "Ciudad",
      field: "cityName",
      editable: "never",
      render: (rowData) => rowData.cityName || "—",
    },
    {
      title: "Tipo vehículo",
      field: "carType",
      editable: "never",
      render: (rowData) => {
        if (!rowData.carType) return "—";
        return (
          <C2StatusChip
            tone="neutral"
            label={t(getLangKey(rowData.carType)) || rowData.carType}
            dot={false}
          />
        );
      },
    },
    {
      title: t("Docs"),
      field: "vehicleNumber",
      render: (rowData) =>
        rowData.vehicleNumber && rowData.licenseImage ? rowData.vehicleNumber : (rowData.vehicleNumber || "—"),
    },
    {
      title: t("mobile"),
      field: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.mobile : t("hidden_demo"),
    },
    {
      title: t("email"),
      field: "email",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.email : t("hidden_demo"),
      headerStyle: { textAlign: "center" },
    },
    {
      title: t("profile_image"),
      field: "profile_image",
      render: (rowData) => (
        <C2UserAvatar src={rowData.profile_image} firstName={rowData.firstName} lastName={rowData.lastName} />
      ),
      editable: "never",
    },
    {
      title: t("account_approve"),
      field: "approved",
      type: "boolean",
      render: (rowData) => {
        const approval = getDriverApprovalStatus(rowData);
        const isReup = isReuploadedAfterReject(rowData);
        return (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
            <C2Switch
              disabled={!settings.AllowCriticalEditsAdmin}
              checked={rowData.approved}
              onChange={() => handelApproved(rowData)}
            />
            <C2StatusChip
              tone={
                approval === "approved"
                  ? "success"
                  : approval === "rejected"
                  ? "danger"
                  : approval === "no_docs"
                  ? "neutral"
                  : "warning"
              }
              label={
                approval === "approved"
                  ? "Aprobado"
                  : approval === "rejected"
                  ? "Rechazado"
                  : isReup
                  ? "Reenviado"
                  : approval === "no_docs"
                  ? "Sin documentos"
                  : "Pendiente"
              }
            />
          </Box>
        );
      },
    },
    {
      title: t("driver_active"),
      field: "driverActiveStatus",
      editable: "never",
      type: "boolean",
      render: (rowData) => (
        <C2Switch
          disabled
          checked={rowData.driverActiveStatus}
          onChange={() => handelDriverActiveStatus(rowData)}
        />
      ),
    },
    {
      title: t("queue"),
      field: "queue",
      editable: "never",
      type: "boolean",
      initialEditValue: true,
      render: (rowData) => (
        <C2Switch
          disabled
          checked={rowData.queue}
          onChange={() => console.log(rowData.queue)}
        />
      ),
    }
  ];

  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const [selectedRow, setSelectedRow] = useState(null);

  const tableComponents = c2Toolbar(
    pendingDocsCount > 0 ? (
      <Tooltip title="Filtrar conductores con documentos pendientes de revisión">
        <Box
          onClick={() => setStatusFilter(statusFilter === "pending_docs" ? "" : "pending_docs")}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.7,
            px: 1.4,
            py: 0.6,
            borderRadius: "10px",
            bgcolor: statusFilter === "pending_docs" ? "#E65100" : "#FFF3E0",
            color: statusFilter === "pending_docs" ? "#FFFFFF" : "#E65100",
            border: "1.5px solid #FF9800",
            cursor: "pointer",
            fontWeight: 800,
            fontSize: "0.8rem",
            fontFamily: C2_FONT,
            boxShadow: "0 2px 8px rgba(255,152,0,0.2)",
            transition: "all 0.2s ease",
            "&:hover": {
              transform: "translateY(-1px)",
              boxShadow: "0 4px 12px rgba(255,152,0,0.35)",
            },
          }}
        >
          <NotificationsActiveOutlinedIcon sx={{ fontSize: 17 }} />
          <span>{pendingDocsCount} {pendingDocsCount === 1 ? "doc por revisar" : "docs por revisar"}</span>
        </Box>
      </Tooltip>
    ) : null,
    <C2Select
      id="driver-sort-filter"
      label="Ordenar por"
      value={sortFilter}
      onChange={(e) => setSortFilter(e.target.value)}
      minWidth={230}
      options={[
        { value: "createdAt_desc", label: "Registro (recientes primero)" },
        { value: "docs_desc", label: "Últimos docs subidos primero" },
      ]}
    />,
    <C2Select
      id="driver-status-filter"
      label="Estado"
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
      minWidth={170}
      options={[
        { value: "", label: "Todos los estados" },
        { value: "pending_docs", label: "Por revisar documentos" },
        { value: "pending", label: "Pendiente" },
        { value: "approved", label: "Aprobado" },
        { value: "rejected", label: "Rechazado" },
        { value: "reuploaded", label: "Reenviaron documento" },
        { value: "no_docs", label: "Sin documentos" },
      ]}
    />,
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        backgroundColor: "#FFFFFF",
        borderRadius: "10px",
        border: `1px solid ${C2.border}`,
        px: 1,
        py: 0.4,
        height: 40,
        boxSizing: "border-box",
      }}
    >
      <Typography sx={{ fontFamily: C2_FONT, fontSize: "0.78rem", color: C2.muted, whiteSpace: "nowrap" }}>
        Día:
      </Typography>
      <input
        type="date"
        value={dateFilter}
        onChange={(e) => setDateFilter(e.target.value)}
        style={{
          border: "none",
          outline: "none",
          fontFamily: C2_FONT,
          fontSize: "0.85rem",
          color: C2.dark,
          backgroundColor: "transparent",
          cursor: "pointer",
        }}
      />
      {dateFilter ? (
        <IconButton
          size="small"
          onClick={() => setDateFilter("")}
          sx={{ p: 0.2, color: C2.muted, "&:hover": { color: C2.dark } }}
          title="Limpiar fecha"
        >
          <ClearIcon sx={{ fontSize: 16 }} />
        </IconButton>
      ) : null}
    </Box>,
    <C2Select
      id="driver-vehicle-filter"
      label="Tipo vehículo"
      value={vehicleFilter}
      onChange={(e) => setVehicleFilter(e.target.value)}
      minWidth={170}
      options={[
        { value: "", label: "Todos los vehículos" },
        { value: "__none__", label: "Sin vehículo" },
        ...vehicleFilterOptions.map((v) => ({
          value: v,
          label: t(getLangKey(v)) || v,
        })),
      ]}
    />,
    <C2Select
      id="driver-city-filter"
      label="Filtrar por ciudad"
      value={cityFilter}
      onChange={(e) => setCityFilter(e.target.value)}
      minWidth={180}
      options={[
        { value: "", label: "Todas las ciudades" },
        { value: "__none__", label: "Sin ciudad" },
        ...cityFilterOptions.map((c) => ({ value: c.id, label: c.name })),
      ]}
    />,
    <C2AddButton
      label="Agregar conductor"
      onClick={() => navigate("/users/edituser/driver",{state:{pageNo:currentPage}})}
    />
  );
  const tableLocalization = c2Localization(
    localization(t),
    <C2EmptyState
      icon={DirectionsCarOutlinedIcon}
      message={
        cityFilter || statusFilter || dateFilter || vehicleFilter
          ? "No hay conductores para los filtros seleccionados. Prueba ajustando los criterios de búsqueda."
          : "Aún no hay conductores registrados. ¡Agrega el primero y empieza a operar con Conecta2!"
      }
    />
  );

  return !loaded.current ? (
    <CircularLoading />
  ) : (
    <div>
      <ThemeProvider theme={c2TableTheme}>
      <C2TableCard>
      {sortedData?.length >0 ? 
        <MaterialTable
          title={t("drivers_title")}
          columns={columns}
          onChangePage={(page)=>HandalePageChange(page)}
          style={c2TableStyle(isRTL)}
          data={filteredData}
          components={tableComponents}
          onRowClick={(evt, selectedRow) =>
            setSelectedRow(selectedRow.tableData.id)
          }
          options={{
            ...c2TableOptions(selectedRow),
            pageSize: 20,
            pageSizeOptions: [10, 20, 50, 100],
            initialPage:state?.pageNo,
            exportCsv: (columns, data) => {
              let hArray = [];
              const headerRow = columns.map((col) => {
                if (typeof col.title === "object") {
                  return col.title.props.text;
                }
                hArray.push(col.field);
                return col.title;
              });
              const dataRows = data.map(({ tableData, ...row }) => {
                row.createdAt =
                  new Date(row.createdAt).toLocaleDateString() +
                  " " +
                  new Date(row.createdAt).toLocaleTimeString();
                row.fleetadmin = row.fleetadmin
                  ? fleetAdminsObj[row.fleetadmin]
                  : "";
                let dArr = [];
                for (let i = 0; i < hArray.length; i++) {
                  dArr.push(row[hArray[i]]);
                }
                return Object.values(dArr);
              });
              const { exportDelimiter } = ",";
              const delimiter = exportDelimiter ? exportDelimiter : ",";
              const csvContent = [headerRow, ...dataRows]
                .map((e) => e.join(delimiter))
                .join("\n");
              const csvFileName = "download.csv";
              downloadCsv(csvContent, csvFileName);
            },
            exportButton: {
              csv: settings.AllowCriticalEditsAdmin,
              pdf: false,
            },
            maxColumnSort: "all_columns",
          }}
          localization={tableLocalization}
          editable={{
            onRowDelete: (oldData) =>
              settings.AllowCriticalEditsAdmin
                ? new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      dispatch(deleteUser(oldData.id));
                      dispatch(fetchUsersOnce());
                    }, 600);
                  })
                : new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      alert(t("demo_mode"));
                    }, 600);
                  }),
          }}
          actions={[
            (rowData) => ({
              tooltip: t("edit"),
              icon: () => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginRight:0
                }}
              >
                <EditIcon />  
              </div>
            ),
            onClick: (event, rowData) =>{
              navigate(`/users/edituser/driver/${rowData.id}`,{state:{pageNo:currentPage}})
            }
          }),
            {
              icon: "info",
              tooltip: t("profile_page_subtitle"),
              onClick: (event, rowData) => {
                navigate(`/users/driverdetails/${rowData.id}`,{state:{pageNo:currentPage}});
              },
            },
            (rowData) => {
              const isPending = hasPendingDocReview(rowData);
              const isReup = isReuploadedAfterReject(rowData);
              const isVerified = isUserDocVerified(rowData);
              return {
                icon: () => (
                  <C2DocsBadge isPending={isPending} isReup={isReup}>
                    <C2DocsChip label={t("documents")} />
                  </C2DocsBadge>
                ),
                tooltip: isPending
                  ? isReup
                    ? "⚠️ Conductor rechazado reenvió documentos para revisión"
                    : "⚠️ Documento subido pendiente de revisión y aprobación"
                  : isVerified
                  ? "Documento verificado y aprobado"
                  : t("documents"),
                onClick: () => setDocsUser(rowData),
              };
            },
          ]}
        />
        :  <BlankTable title={t('drivers_title')}  columns={columns} 
      actions={[]}
      components={tableComponents}
      style={c2TableStyle(isRTL)}
      data={[]} localization={tableLocalization} options={{ ...c2TableOptions(null), pageSize: 20, pageSizeOptions: [10, 20, 50, 100] }}/>}
      </C2TableCard>
        </ThemeProvider>
      <VerifyIdDocumentModal
        open={!!docsUser}
        user={docsUser}
        onClose={() => setDocsUser(null)}
      />
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
}
